import firebase from 'firebase';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const sendQuoteCSV = async (quote: any[][]): Promise<void> => {
    const quoteString = quote.map((item) => item.join(';')).join('\n');
    const sendQuote = firebase.functions().httpsCallable('sendQuoteCSV');
    sendQuote(quoteString);
};
